module.exports = __webpack_public_path__ + "static/media/baby_dress.3a23615a.jpg";